import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import label from "../../labels/accessRightsManagement_en.json";
import { useForm } from "react-hook-form";
import commonLabels from "../../../common/labels/common_en.json";
import _ from "lodash/fp";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getUserListing,
  saveNewUserData,
} from "../../actions/accessRightsManagementActions";
import { getSupervisorlist } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getUserRoles } from "../../../common/actions/commonActions";
const UpdateUser = (props) => {
  const { register, errors, handleSubmit, formState, watch } = useForm({
    mode: "onChange",
  });
  const dispatch = useDispatch();

  let { allDepartments } = useSelector((state) => state?.common, shallowEqual);
  let { userRolesList } = useSelector((state) => state?.common, shallowEqual);
  let { userListing, unapprovedUser_list, getUser } = useSelector(
    (state) => state?.accessRightsManagementReducer,
    shallowEqual
  );
  useEffect(() => {
    dispatch(getUserRoles());
    dispatch(getSupervisorlist());
    dispatch(getUserListing());
  }, []);
  const [checkboxData, setCheckBoxData] = useState(true);
  const [updatedMobile, setUpdatedMobile] = useState("");
  const [updatedEmail, setupdatedEmail] = useState("");
  const [updatedLastName, setUpdatedLastName] = useState("");
  const [updatedFirstName, setUpdatedFirstName] = useState("");
  const [updatedDepartment, setUpdatedDepartment] = useState("");
  const [updatedRole, setUpdatedRole] = useState("");
  const [updatedSupervisior,setUpdatedSupervisior]=useState("");
 

    const value = props?.setUpdatedValue?.userDeptRole?.map((item, ind) => item) || [];
   
    const userApprovalDeptRoleDto = value.map((item) => ({
      department: {
        id: parseInt(updatedDepartment) || item.department.id,
      },
      role: {
        id: parseInt(updatedRole)||item.role.id,
      },
      supervisor: {
        id: parseInt(updatedSupervisior)||item.supervisor?.id,
      },
      isActive: true,
    }));
  const onSubmit = () => {
  
    let data = {
        userApproval: {
          approvalType: "Edit User",
          status: "Approval1_Pending",

          userId: props?.setUpdatedValue?.user?.id,
          email: updatedEmail || props?.setUpdatedValue?.user?.email,
          mobile: updatedMobile || props?.setUpdatedValue?.user?.mobile,
          password: "Password@2",
          isSuperAdmin: "true",
          isActive: checkboxData || props?.setUpdatedValue?.user?.isActive,
          firstName: updatedFirstName || props?.setUpdatedValue?.user?.firstName,
          lastName: updatedLastName || props?.setUpdatedValue?.user?.lastName,
        },
        userApprovalDeptRoleDto: userApprovalDeptRoleDto,
      };
      dispatch(saveNewUserData(data));
    props.setShowUpdateModal(false);
  };
  const onhandleisActive = (ele) => {
    setCheckBoxData(ele.target.checked);
  };
  const onChangeDepartment = (e) => {
    setUpdatedDepartment(e.target.value);

    // dispatch(getUserRoles());
  };
  return (
    <Modal
      size="xl"
      show={props.showUpdateModal}
      onHide={() => {
        props.setShowUpdateModal(false);
      }}
      aria-labelledby="example-modal-sizes-title-xs"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-xs">Update User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-3">
            <label className="float-left">
              {label.Department}
              <span className="errorText">*</span>
            </label>
            <select
              // #selectDept
              className="form-control"
              name="departmentName"
              // disabled={showoptions}

              value={
                updatedDepartment
                  ? updatedDepartment
                  : props?.setUpdatedValue?.userDeptRole &&
                    props?.setUpdatedValue?.userDeptRole.length > 0 &&
                    props?.setUpdatedValue?.userDeptRole[0]?.department?.id
              }
              // ref={register({ required: true })}
              onChange={(e) => {
                onChangeDepartment(e);
              }}
            >
              <option key={0} value="">
                {commonLabels.COMBO_SELECT}
              </option>
              {allDepartments &&
                allDepartments.length > 0 &&
                allDepartments.map((element, index) => (
                  <option key={index} value={element.id}>
                    {element.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-3">
            <label className="float-left">
              {label.Authority}
              <span className="errorText">*</span>
            </label>
            <select
              className="form-control"
              name="role"
              // disabled={showoptions}
              value={
                updatedRole
                  ? updatedRole
                  : props?.setUpdatedValue?.userDeptRole &&
                    props?.setUpdatedValue?.userDeptRole.length > 0 &&
                    props?.setUpdatedValue?.userDeptRole[0]?.role?.id
              }
              // ref={register({ required: true })}
              onChange={(e) => {
                setUpdatedRole(e.target.value);
              }}
            >
              <option key={0} value="">
                {commonLabels.COMBO_SELECT}
              </option>
              {userRolesList &&
                userRolesList.length > 0 &&
                userRolesList.map((element, index) => (
                  <option key={index} value={element.id}>
                    {element.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-3">
            <label className="float-left">
              {label.Supervisior}
              <span className="errorText">*</span>
            </label>
            <select
              className="form-control"
              name="supervisior"
              // disabled={showoptions}
              value={updatedSupervisior?updatedSupervisior:
                props?.setUpdatedValue?.userDeptRole &&
                props?.setUpdatedValue?.userDeptRole.length > 0 &&
                props?.setUpdatedValue?.userDeptRole[0]?.supervisor?.id
              }
              // ref={register({ required: true })}
              onChange={(e) => {
                setUpdatedSupervisior(e.target.value);
              }}
            >
              <option key={0} value="">
                {commonLabels.COMBO_SELECT}
              </option>
              {getUser &&
                getUser.length > 0 &&
                getUser.map((element, index) => (
                  <option key={index} value={element.id}>
                    {element.firstName + " " + element.lastName}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-3">
            <label className="float-left">
              {label.firstName}
              <span className="errorText">*</span>
            </label>
            <input
              type="text"
              name="firstName"
              defaultValue={props?.setUpdatedValue?.user?.firstName}
              onChange={(e) => {
                setUpdatedFirstName(e.target.value);
              }}
              className="form-control"
              maxLength={15}
              pattern="[A-Za-z]+"
              ref={register({
                required: true,
                pattern: /^[A-Za-z]+( [A-Za-z]+)*$/,
              })}
            />
            {_.get("firstName.type", errors) === "required" && (
              <p className="errorText float-left">
                {commonLabels.MANDATORY_FIELD_MESSAGE}
              </p>
            )}
            {_.get("firstName.type", errors) === "pattern" && (
              <p className="errorText float-left">
                {commonLabels.Onlyalphabeticcharactersareallowed}
              </p>
            )}
          </div>
          <div className="col-md-3">
            <label className="float-left">
              {label.lastName}
              <span className="errorText">*</span>
            </label>
            <input
              type="text"
              name="lastName"
              defaultValue={props?.setUpdatedValue?.user?.lastName}
              onChange={(e) => {
                setUpdatedLastName(e.target.value);
              }}
              className="form-control"
              maxLength={25}
              pattern="[A-Za-z]+"
              ref={register({
                required: true,
                pattern: /^[A-Za-z]+( [A-Za-z]+)*$/,
              })}
            />
            {_.get("lastName.type", errors) === "required" && (
              <p className="errorText float-left">
                {commonLabels.MANDATORY_FIELD_MESSAGE}
              </p>
            )}
            {_.get("lastName.type", errors) === "pattern" && (
              <p className="errorText float-left">
                {commonLabels.Onlyalphabeticcharactersareallowed}
              </p>
            )}
          </div>
          <div className="col-md-3">
            <label className="float-left">
              {label.UserEmailId}
              <span className="errorText">*</span>
            </label>
            <input
              type="text"
              name="email"
              defaultValue={props?.setUpdatedValue?.user?.email}
              onChange={(e) => {
                setupdatedEmail(e.target.value);
              }}
              className="form-control"
              ref={register({
                required: true,
                pattern: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/,
              })}
            />
            {_.get("email.type", errors) === "required" && (
              <p className="errorText float-left">
                {commonLabels.MANDATORY_FIELD_MESSAGE}
              </p>
            )}
            {_.get("email.type", errors) === "pattern" && (
              <p className="errorText float-left">
                {commonLabels.Invalidemailaddress}
              </p>
            )}
          </div>
          <div className="col-md-3">
            <label className="float-left">
              {label.Usermobile}
              <span className="errorText">*</span>
            </label>
            <input
              type="text"
              name="Usermobile"
              defaultValue={props?.setUpdatedValue?.user?.mobile}
              onChange={(e) => {
                setUpdatedMobile(e.target.value);
              }}
              className="form-control"
              maxLength={10}
              ref={register({
                required: true,
                pattern: /^[6-9][0-9]{9}$/,
              })}
            />
            {_.get("Usermobile.type", errors) === "required" && (
              <p className="errorText float-left">
                {commonLabels.MANDATORY_FIELD_MESSAGE}
              </p>
            )}
            {_.get("Usermobile.type", errors) === "pattern" && (
              <p className="errorText float-left">
                {
                  commonLabels.Pleaseenteravalid10digitmobilenumberstartingwith678or9
                }
              </p>
            )}
          </div>
          <div className="col-md-3">
            <label className="float-left">
              {label.isActive}
              <span className="errorText">*</span>
            </label>
            <input
              type="checkbox"
              id="isActive"
              name="isActive"
              defaultChecked={props?.setUpdatedValue?.user?.isActive}
              // className="form-control"
              //   ref={register({ required: true })}
              checked={checkboxData}
              onChange={(event) => onhandleisActive(event)}
            />
          </div>
        </div>
        <div className="row custom-button text-align-right">
          <button
            className="btn btn-secondary ml-auto mr-2"
            type="button"
            onClick={() => {
              props.setShowUpdateModal(false);
            }}
          >
            {label.Cancel}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit((e) => {
              onSubmit(e);
            })}
          >
            {label.Save}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateUser;
